/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DefaultPeriodConfig
 */
export interface DefaultPeriodConfig {
    /**
     * Number of days in past to backfill from. 0 is no backfill. e.g) if 10, then backfill last 10 days of data. Required if fullHistory is not set.
     * @type {number}
     * @memberof DefaultPeriodConfig
     */
    days?: number;
    /**
     * If true, backfill all history. Required if days is not set.
     * @type {boolean}
     * @memberof DefaultPeriodConfig
     */
    fullHistory?: boolean;
}

/**
 * Check if a given object implements the DefaultPeriodConfig interface.
 */
export function instanceOfDefaultPeriodConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DefaultPeriodConfigFromJSON(json: any): DefaultPeriodConfig {
    return DefaultPeriodConfigFromJSONTyped(json, false);
}

export function DefaultPeriodConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultPeriodConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': !exists(json, 'days') ? undefined : json['days'],
        'fullHistory': !exists(json, 'fullHistory') ? undefined : json['fullHistory'],
    };
}

export function DefaultPeriodConfigToJSON(value?: DefaultPeriodConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': value.days,
        'fullHistory': value.fullHistory,
    };
}

